var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientReportWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2039_3037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.666 8.00065H15.9993L14.1193 6.12065C13.6127 5.61398 12.9327 5.33398 12.226 5.33398H5.33268C3.86602 5.33398 2.67935 6.53398 2.67935 8.00065L2.66602 24.0007C2.66602 25.4673 3.86602 26.6673 5.33268 26.6673H26.666C28.1327 26.6673 29.3327 25.4673 29.3327 24.0007V10.6673C29.3327 9.20065 28.1327 8.00065 26.666 8.00065ZM19.9993 12.0007C21.466 12.0007 22.666 13.2007 22.666 14.6673C22.666 16.134 21.466 17.334 19.9993 17.334C18.5327 17.334 17.3327 16.134 17.3327 14.6673C17.3327 13.2007 18.5327 12.0007 19.9993 12.0007ZM25.3327 22.6673H14.666V21.334C14.666 19.5606 18.226 18.6673 19.9993 18.6673C21.7727 18.6673 25.3327 19.5606 25.3327 21.334V22.6673Z",
    fill: "#FFFDFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2039_3037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientReportWhite);
export default __webpack_public_path__ + "static/media/clientReportWhite.be542b91b97d3c5b1868ba61a793cdd8.svg";
export { ForwardRef as ReactComponent };